var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scale-wrapper",style:({ transform: ("scale(" + _vm.scale + ")") }),on:{"touchstart":_vm.handleScaleStart,"touchmove":_vm.handleScale,"touchend":_vm.handleScaleEnd}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }